import { inject, Injectable } from '@angular/core';

import { ROUTES } from '@core/constants';
import {
  CloseOrderResult,
  IOrdersHistoryResponse,
  IResponseHttp,
  OrderDetail,
} from '@core/models';
import { ApiService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class OrdersHistoryService {
  private readonly api = inject(ApiService);

  async getOrdersHistory(params?: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<IOrdersHistoryResponse> {
    const query = new URLSearchParams();

    if (params?.page) {
      query.set('page', params.page.toString());
    }

    if (params?.pageSize) {
      query.set('pageSize', params.pageSize.toString());
    }

    if (params?.search?.trim()) {
      query.set('search', params.search.trim());
    }

    const url = `${ROUTES.ADMIN_GET_ORDERS_HISTORY}?${query.toString()}`;

    const result = await this.api.get<IResponseHttp>(url);

    return result.payload;
  }

  async getOrderDetail(orderId: string): Promise<OrderDetail> {
    const result = await this.api.get<IResponseHttp>(
      ROUTES.ADMIN_GET_ORDER_HISTORY_DETAIL(orderId),
    );

    return result.payload;
  }

  async finalizeOrder(orderId: string, paid: boolean): Promise<CloseOrderResult> {
    const result = await this.api.put<IResponseHttp>(
      ROUTES.ADMIN_FINALIZE_ORDER_HISTORY(orderId),
      { paid },
    );

    return result.payload;
  }
}
